import { useState, type FormEvent } from 'react';
import { Key, ShieldCheck } from '@phosphor-icons/react';
import { PASSWORD_MIN_LENGTH } from '@longjie/shared';
import { ApiError, request } from './api';
import { BrandMark, Button, Field } from './components';

export function PasswordChange({ onChanged }: { onChanged: () => void }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (newPassword.length < PASSWORD_MIN_LENGTH || newPassword.length > 200) return setError(`新密码需为 ${PASSWORD_MIN_LENGTH} 至 200 位`);
    if (newPassword.toLowerCase() !== confirm.toLowerCase()) return setError('两次输入的新密码不一致');
    setLoading(true);
    setError('');
    try {
      await request('/api/v1/auth/change-password', {
        method: 'POST',
        body: JSON.stringify({ currentPassword, newPassword })
      });
      onChanged();
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : '密码修改失败');
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="password-page">
      <BrandMark />
      <form className="password-card" onSubmit={submit}>
        <span className="password-card__icon"><ShieldCheck weight="duotone" /></span>
        <p className="eyebrow">账号安全</p>
        <h1>首次登录，请设置新密码</h1>
        <p>初始密码只能使用一次。新密码为 {PASSWORD_MIN_LENGTH} 至 200 位，可使用字母、数字或符号，不要求组合。不区分字母大小写，数字和符号原样匹配。</p>
        <p className="field__hint">管理员可协助查看本系统密码，请使用专用密码。</p>
        {error && <div className="inline-error" role="alert">{error}</div>}
        <Field label="当前初始密码"><span className="input-with-icon"><Key /><input type="password" autoComplete="current-password" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} maxLength={200} required /></span></Field>
        <Field label="新密码"><input type="password" autoComplete="new-password" minLength={PASSWORD_MIN_LENGTH} maxLength={200} value={newPassword} onChange={(event) => setNewPassword(event.target.value)} required /></Field>
        <Field label="再次输入新密码"><input type="password" autoComplete="new-password" minLength={PASSWORD_MIN_LENGTH} maxLength={200} value={confirm} onChange={(event) => setConfirm(event.target.value)} required /></Field>
        <Button type="submit" loading={loading}>保存并进入系统</Button>
      </form>
    </main>
  );
}
